export const EMAIL_VALIDATION_REGEX = /^[a-z0-9.]+@stengg\.com$/;
export const FILE_NAME_VALIDATION_REGEX = /^[a-zA-Z0-9\s._-]+$/;
export const NON_NUMERIC_REGEX = /\D/g;
export const EMAIL_VALID_CHARACTERS_REGEX = /[^a-z0-9.@]/g;
